
export const AUTH_URL = '/oauth/token';
export const LOGIN_URL = '/api/login';
export function VERIFY_CODE_URL (id) {
  return `/api/login/verify/${id}`;
}

export const USER_URL = '/api/user'
export const USER_LIST_URL = '/api/user/list'
export const APPLICANT_LIST_URL = 'api/applicant/list'
export const APPLICANT_URL = '/api/applicant'
export const APPLICANT_CREATE_URL = '/api/applicant/create'
export const APPLICANT_STATISTIC_URL = '/api/dashboard/statistic'
export function APPLICANT_EDIT_URL(id){
 return  `api/applicant/${id}`
}
export function APPLICANT_STATUS_URL(id){
  return  `api/applicant/${id}/status`
 }
export function RECOGNITION_URL(id){
    return  `api/applicant/${id}/recognition`
}
export  function RECOGNITION_EDIT_URL(id, recognition_id) {
  return  `api/applicant/${id}/recognition/${recognition_id}`
}
export const RECOGNITION_CREATE_URL = '/api/applicant/recognition/create'

export const INSTITUTION_LIST_URL = '/api/institution-list'
export const LOGS_LIST_URL = '/api/logs'

export const INSTITUTION_CREATE_URL = '/api/institution/create'

export const COUNTRIES_LIST = '/api/countries'
export const PUBLIC_COUNTRIES_ORIGIN = '/api/country-list'
export const PUBLIC_QUALIFICATION_LIST = '/api/qualification-list'

export const DOCUMENT_URL = '/api/document';

export const CONTACTS_LIST = '/api/contacts/list'

export const CONTACTS_CREATE = '/api/contacts/create'

export function CONTACTS_EDIT(id){
  return  `api/contacts/${id}`
 }

export function INSTITUTION_EDIT_URL(id) {
  return  `api/institution/${id}`
}
export const AUTH_URL_MAGIC_LINK = 'api/user/magic-link-token'

export const ECONOMY_LIST = '/api/economies-list'

export const ROLE_LIST = '/api/roles/list'
export const STATUS_LIST = '/api/status/list'

export const COMPARISON_STATISTICS_URL = '/api/comparison-statistics'
export const STATISTICS_URL = '/api/statistics'
